import { useAuthStore } from '@/features/auth/useAuthStore.js'
import { AUTH_FLOW, reportAuthFlowError } from '@/features/auth/utils/reportAuthFlowError.js'

export async function sessionGuard(to, from, next) {
  // Skip guard for error page to prevent infinite loops
  const isOnErrorPage = to?.name === 'error' || to?.path?.includes('/error')

  if (isOnErrorPage) {
    next()
    return
  }

  const authStore = useAuthStore()
  try {
    console.log('[sessionGuard] Starting getMyDetails')
    await authStore.getMyDetails()
    console.log('[sessionGuard] getMyDetails completed successfully')
  } catch (e) {
    reportAuthFlowError({
      flow: AUTH_FLOW.SESSION,
      step: 'session-guard',
      error: e,
    })
    throw e
  }

  next()
}
